import Box from '@mui/material/Box';
import { FC } from 'react';
import { connect } from 'react-redux';
import { BACKEND_URL, CLIENT_ID, DASHBOARD_URL } from 'src/constants';
import { getImageURL } from 'src/helpers';
import { TAppSlice } from 'src/redux/appSlice';
import { RootState } from 'src/redux/store';
import { TrustedWidget, TrustedWidgetConfig } from 'trusted-widget';
import styles from './TopBar.module.css';
import { useTheme } from '@mui/material';
import { borderRadius } from './custom/Theme';

const mapStateToProps = (state: RootState) => ({
  clientProfile: state.app.clientProfile,
});

interface ITopBarProps {
  clientProfile: TAppSlice['clientProfile'];
}

const TopBarComponent: FC<ITopBarProps> = ({ clientProfile }) => {
  const theme = useTheme();

  const newConfig: TrustedWidgetConfig = {
    appId: CLIENT_ID,
    issuer: BACKEND_URL,
    backendUrl: BACKEND_URL,
    redirectUrl: DASHBOARD_URL + '/login',
    withOutHomePage: true,
    customStyles: {
      global: {
        color: {
          text: theme.palette.custom.mainGrey,
          background: theme.palette.custom.background,
        },
        borderRadius: borderRadius,
      },
      components: {
        accountButton: {
          text: theme.palette.custom.main,
        },
        primaryButton: {
          text: theme.palette.custom.onAccentColor,
          background: theme.palette.custom.accent,
          hover: theme.palette.custom.accentHover,
        },
        secondaryButton: {
          text: theme.palette.custom.onSecondaryAccentColor,
          background: theme.palette.custom.secondaryAccent,
          hover: theme.palette.custom.secondaryAccentHover,
        },
      },
    },
  };

  return (
    <>
      <Box id="top-bar" className={styles.topBar}>
        <img className={styles.logo} src={getImageURL(clientProfile?.avatar) || ''} />
        <span className={styles.title}>{clientProfile?.name}</span>
        <div className={styles.profile}>
          <TrustedWidget config={newConfig} />
        </div>
      </Box>
    </>
  );
};

export const TopBar = connect(mapStateToProps)(TopBarComponent);
